import { render, staticRenderFns } from "./login_orig.vue?vue&type=template&id=25c4a3d2&scoped=true&"
import script from "./login_orig.vue?vue&type=script&lang=js&"
export * from "./login_orig.vue?vue&type=script&lang=js&"
import style0 from "./login_orig.vue?vue&type=style&index=0&id=25c4a3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4a3d2",
  null
  
)

export default component.exports